import PageLayout from "@/components/PageLayout";
import ProductCollectionsService from "@/lib/services/product_collections.js";
import Paginator from "@/components/paginator";
import ProductFilterSidebar from '@/components/product_filter_sidebar';
import ProductTile from "@/components/product_tile";
import SearchBuilder from '@/components/search_builder.js' 
import { useState, useReducer, useEffect, useContext } from "react";
import Qs from "qs";
import searchTranslator from "@/lib/search_translator.js";
import Loader from "@/components/loading_animation.js";
import { loadConfig, extractIdFromSlug } from "@/lib/utils.js";
import DropdownFilter from "@/components/dropdown_filter";
import AnalyticService from "@/lib/services/analytics";
import InfiniteScroll from "@/components/infinite_scroll.js";
import {ProductCacheContext } from '@/lib/product_cache_context.js'; 

function CollectionsPage(results) {
  const {
    products,
    total_count,
    initialSearch,
    page_layout,
    favicon,
    stylesheet,
    cart_enabled,
    collection,
    attribute_filters,
    product_type_filters, 
    attribute_filters_position, 
    enable_infinite_scroll_on_product_pages
  } = results;


  const useInfiniteScroll = enable_infinite_scroll_on_product_pages; 
  const [isPageChange, setIsPageChange] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  
  const prodCache = useContext(ProductCacheContext); 


  const searchProducts = (search, pageChange) => {
    setIsLoading((currentIsLoaded) => true);
    setIsPageChange(pageChange)
    if (!pageChange) {
      useInfiniteScroll ?  prodCache.setPage(1) : null;  
    }
    fetch('/lex-api/product-collections/' + prodCache?.collection?.id   + '?' +  Qs.stringify(search, {arrayFormat: 'brackets', encode: true}))
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        (useInfiniteScroll && pageChange)  ? prodCache.appendProducts(data.products ) : prodCache.setItems(data.products)  

        prodCache.setAttributeFilters(data.attribute_filters || []);
        prodCache.setTypeOptions(data.product_type_filters)
        prodCache.setTotalCount(data.total_count)
      }).catch((e) => alert(e))
  }


   useEffect(() => {
    prodCache?.items?.length > 0 ? null : prodCache.setItems(products); 
    prodCache?.totalCount >  0 ? null: prodCache.setTotalCount(total_count);
    prodCache?.attributeFilters.length > 0 ?  null : prodCache.setAttributeFilters(attribute_filters || [])
    prodCache?.typeOptions.length > 0 ? null : prodCache.setTypeOptions(product_type_filters || [] )
    prodCache?.collection  ? null : prodCache.setCollection(collection || {})
   }, [])


  return (
    <PageLayout
      title={`${prodCache?.collection?.name}`}
      cart_enabled={cart_enabled}
      page_layout={page_layout}
      favicon={favicon}
      pageBanner={prodCache?.collection?.image }
      stylesheet={stylesheet}
      breadcrumbs={ (<a href={'/lex-cms/all_collections'}>&lt; View All Collections</a>) }
     >
      <SearchBuilder initialSearch={initialSearch} search={searchProducts}> 
        {(searchState) =>  {
          return (
            <section className="lexcms-collections-page-container">
              <div className='lexcms-header-container'>
                <h1 className="lexcms-collection-name">{prodCache?.collection?.name} <span>Collection</span></h1>
                {prodCache.typeOptions?.length > 0 &&
                <div className="lexcms-product-search-top-filter-container">

                <div className="lexcms-product-search-top-filters">
                  <DropdownFilter
                    searchKey={"q[tags_id_eq]"}
                    className="lexcms-product-search-top-product-type-filter"
                    searchState={searchState}
                    options={prodCache.typeOptions}
                    label={"Product Type Filter"}
                  />
                  <button
                    onClick={() => {
                      searchProducts({});
                      searchState.clearAll();
                    }}
                    className="lexcms-regular-button lexcms-product-search-clear-results-button"
                  >
                    Clear Results
                  </button>
                </div>
                </div>
                }
              </div>
                  {prodCache?.collection?.description &&
                  <div className='lexcms-collection-description'>
                     {prodCache.collection.description}
                  </div>
                  }
                 
                  <div className="lexcms-product-search-top-filter-pills-container">
                    {prodCache.selectedAttributes(searchState.search).map((attr, i) => {
                      return (
                        <div
                          key={i}
                          className="lexcms-product-search-top-filter-pill"
                        >
                          {attr.display_value}
                          <div
                            onClick={() =>
                              searchState.removeFromValuesAtKey(
                                "q[has_attribute_values][]",
                                attr.id.toString()
                              )
                            }
                            className="lexcms-product-search-top-filter-pill-close"
                          >
                            x
                          </div>
                        </div>
                      );
                    })}
                  </div>
                 {!useInfiniteScroll &&
                  <div className="lex-cms-pagination-top">
                    {prodCache.totalCount > 50 &&
                    <Paginator itemsPerPage={50} pageRangeDisplayed={5} totalCount={prodCache.totalCount} 
                    search={searchState}   />
                    }
                  </div>
                 }
              <section className="lexcms-collections-page-body-container">
                <ProductFilterSidebar attributeFiltersPosition={attribute_filters_position} searchState={searchState} attributeFilters={prodCache.attributeFilters}  />
                <div className={
                    (prodCache.attributeFilters.length > 0
                      ? "lexcms-collections-container-with-sidebar"
                      : "lexcms-collections-container-no-sidebar")
                  }>
                  <div className={"lexcms-product-tile-grid-container"}>
                     {isLoading && (!useInfiniteScroll || !isPageChange) && <Loader />}
                    {prodCache.items &&
                        prodCache.items.length > 0 &&
                        prodCache.items.map((product, i) => {
                          return (
                            <ProductTile attributesApplied={prodCache.attributesApplied} key={product.id} product={product} />
                          );
                        })}
                  </div>
                </div>
              </section>
              {useInfiniteScroll ? (<InfiniteScroll itemsPerPage={50}
                 pageRangeDisplayed={5}
                 totalCount={prodCache.totalCount}
                 loading={isLoading}
                 search={searchState} /> ) :
               (<div className="lex-cms-pagination-bottom">
                {prodCache.totalCount > 50 && (
                  <Paginator
                    itemsPerPage={50}
                    pageRangeDisplayed={5}
                    totalCount={prodCache.totalCount}
                    search={searchState}
                  />
                )}
              </div> ) 
              }

            </section>
          )
        }}
      </SearchBuilder>
      </PageLayout>
        );
   }
export async function getServerSideProps(context) {
  let token = context?.req?.headers['lex-api-token'] 
  let service = await ProductCollectionsService.build(token, context.req?.headers?.host);
  let id = extractIdFromSlug(context.params)
  let search = {}
  let pageConfig = loadConfig(service)

  let q =  searchTranslator(context.query || {})
  search.initialSearch = q

  let apiFriendlyQ = searchTranslator(context.query || {}, true)

  if (context.query?.clientNavigation) {
    //back navigation so data should already be in memory

    return {props: { ...pageConfig,...search} }
  }

  try {
    let resp = await service.show(id, apiFriendlyQ);
    search = {...search, ...resp}

  } catch (e) {

    return {
      notFound: true,
    };
  }

  try {
    let analyticService = new AnalyticService(token, {}, true);
    let data = { 
      collection_id: id
    }
    analyticService.recordCollectionPageVisit(data, context.req?.headers);

  } 
  catch (e) {
    console.log(e);
  }
  return {
    props: { ...search, ...pageConfig },
  };
}

export default CollectionsPage;
